import getWebShellClientLocale from './get-webshellclient-locale';

/**
 * deriveUrlWithFragment builds a basic Nike application url with locale parameters.
 * Uses window.location.origin at runtime so the URL respects the current domain
 * (e.g. uat.nike.com vs www.nike.com) rather than a build-time env var.
 * @param {string} pathParameter - Nike route path associated with a Nike experience app.
 * @returns {string} fully constructed url
 */
var deriveUrlWithFragment = function deriveUrlWithFragment(pathParameter) {
  var locale = getWebShellClientLocale();
  var urlLocale = locale === null || locale === void 0 ? void 0 : locale.cloudUrlFragment;
  var urlLocaleFragment = urlLocale ? "/".concat(urlLocale, "/") : '/';
  return "".concat(window.location.origin).concat(urlLocaleFragment).concat(pathParameter);
};
export default deriveUrlWithFragment;